import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import useEmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters/hooks/useEmployeeMultiFilters'

import getFilterValue from 'modules/shift_management/components/ShiftManagement/Content/filters/getFilterValue'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useFilters } from 'modules/shift_management/hooks/useFilters'

import { SHIFT_MANAGEMENT_FILTERS } from './reducers/filter'

const useLocationIdsFilter = (): number[] => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  const { filters: employeeFilters } = useEmployeeMultiFilters(
    getFilterValue,
    LOCAL_STORAGE_KEYS.shiftEmployees,
    { newEntryFlowEnabled }
  )
  const [filters] = useFilters()

  const locationIds = newEntryFlowEnabled
    ? filters.locationIds
    : employeeFilters
        .filter((f) => f.values.field === SHIFT_MANAGEMENT_FILTERS.employeeLocation)
        .map((f) => f.values.value)

  return locationIds.map((id) => Number(id))
}

export default useLocationIdsFilter
